import React, { Component } from "react";
import _ from "lodash";
import { SelectInput, withIgnoreUnderScore } from "~/core";
import { model } from "../../data";
import { adminData } from "~/admin/data";
import { ImportAttribute, SampleAttribute, SelectableAttribute } from "../../data/model";

interface UpdateManualImportAttributesValue {
    importAttributeGuid: string;
    columnOrderInFile: number;
}

interface UpdateManualImportAttributes {
    value: UpdateManualImportAttributesValue;
}

interface ITemplateManagerManualGridProps {
    sampleAttributes: SampleAttribute[];
    importAttributes: ImportAttribute[];
    updateManualImportAttributes: (payload: UpdateManualImportAttributes) => void;
}

export class TemplateManagerManualGrid extends Component<ITemplateManagerManualGridProps> {
    NewSelectInput = withIgnoreUnderScore(SelectInput);

    // Stateless by design: options are derived from props in render. A previous
    // version mirrored sampleAttributes into state and synced it in
    // componentDidUpdate, but the props-only shouldComponentUpdate blocked the
    // state-sync render — the dropdowns kept their mount-time (usually empty)
    // options forever when the grid mounted before the attributes fetch returned.
    shouldComponentUpdate(nextProps: ITemplateManagerManualGridProps): boolean {
        return (
            nextProps.sampleAttributes !== this.props.sampleAttributes ||
            nextProps.importAttributes !== this.props.importAttributes
        );
    }

    prepareSelectableOptions = (options: SampleAttribute[]): model.SelectableAttribute[] =>
        options.reduce((result: SelectableAttribute[], option) => {
            result.push({
                value: option.sampleAttributeGuid,
                label: option.sampleAttributeName,
            });
            return result;
        }, []);

    onSampleAttributeChange = (importAttributeGuid: string, columnOrderInFile: number): void => {
        this.props.updateManualImportAttributes({
            value: {
                importAttributeGuid: importAttributeGuid || "",
                columnOrderInFile,
            },
        });
    };

    getSelectableOptions = (importAttributeGuid: string): model.SelectableAttribute[] => {
        const selectedSampleAttributes = this.props.importAttributes;
        const sampleAttributes = this.prepareSelectableOptions(this.props.sampleAttributes || []);
        _.remove(sampleAttributes, (attr) => {
            for (const key in selectedSampleAttributes) {
                if (
                    attr.value ===
                        selectedSampleAttributes[key][model.PROPS_IMPORT_ATTRIBUTE_GUID] &&
                    attr.value !== importAttributeGuid
                ) {
                    return true;
                }
            }
            return false;
        });
        return sampleAttributes;
    };

    renderManualAttributes = (): JSX.Element[] => {
        const attributesToDisplay = this.props.importAttributes.slice();
        const { NewSelectInput } = this;
        // Add a blank/empty attribute if the last attribute isn't already blank and
        // there are still more attributes to select.
        if (
            attributesToDisplay.length === 0 ||
            (attributesToDisplay[attributesToDisplay.length - 1].importAttributeGuid !== "" &&
                attributesToDisplay.length !== this.props.sampleAttributes.length)
        ) {
            const newImportAttribute = new ImportAttribute("", null);
            newImportAttribute.columnOrderInFile = attributesToDisplay.length;
            attributesToDisplay.push(newImportAttribute);
        }
        return attributesToDisplay
            .sort((a, b) => a.columnOrderInFile - b.columnOrderInFile)
            .map(({ importAttributeGuid }, index) => {
                const displayCount = index + 1;
                return (
                    <div className="import-attribute-cont" key={`${importAttributeGuid}-${index}`}>
                        <span className="counter-cont">{displayCount}</span>
                        <NewSelectInput
                            optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                            value={importAttributeGuid}
                            options={this.getSelectableOptions(importAttributeGuid)}
                            onChange={(value) => this.onSampleAttributeChange(value, index)}
                            placeholderText={""}
                        />
                    </div>
                );
            });
    };

    render(): JSX.Element {
        return (
            <div className="template-manager-grid form-section">
                <div className="template-manager-grid-container">
                    <div className="template-manager-grid-table">
                        <div className="template-manager-attributes">
                            {this.props.sampleAttributes && this.props.sampleAttributes.length > 0
                                ? this.renderManualAttributes()
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
